itsoftApp.createModule("sharing", function () {
    var module = this;
    var moduleInitialized = false;

    var initSharing = function () {
        if (!moduleInitialized) {
            moduleInitialized = true;
            itsoftApp.loadScript("https://yastatic.net/share2/share.js");
        }
    }

    module.callback = initSharing;
});